import React, { useState } from "react";
import ModalCustom from "../../../../components/modal/ModalCustom";
import InputTextField from "../../../../components/input/inputTextField";
import {
  ButtonDel,
  ButtonOutlined,
  ButtonPrimary,
} from "../../../../components/button/ButtonCustoms";

type Props = {
  isOpenModal: boolean;
  setIsOpenModal: (isOpen: boolean) => void;
  onSubmit: () => void;
  inputComment: string;
  setInputComment: (value: string) => void;
};

const ModalSubmitTransferAdvisor: React.FC<Props> = (props: Props) => {
  const {
    isOpenModal,
    setIsOpenModal,
    onSubmit,
    inputComment,
    setInputComment,
  } = props;

  const [errorMessage, setErrorMessage] = useState<string>("");

  return (
    <ModalCustom
      maxWidth={800}
      title={"ส่งคำร้องขอเปลี่ยนอาจารย์ที่ปรึกษาวิทยานิพนธ์"}
      subTitle={
        "กรุณาระบุเหตุผลเพื่อยืนยัน การส่งคำร้องขอเปลี่ยนอาจารย์ที่ปรึกษา"
      }
      open={isOpenModal}
      onClose={() => {
        setIsOpenModal(false);
      }}
      component={
        <section className="grid grid-cols-12 gap-y-6">
          <article className="col-span-12">
            <InputTextField
              value={inputComment}
              helperText={errorMessage}
              type={"text"}
              heading={"หมายเหตุ"}
              placeholder={"ระบุหมายเหตุ"}
              onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setInputComment(e.target.value)
              }
              required
              row={3}
              maxRows={5}
              disablePaddingMultiline
              multiline
              inputHeight={"auto"}
            />
            <p
              className="text-red-500"
              style={{ fontSize: "12px", marginTop: "5px" }}
            >
              {errorMessage}
            </p>
          </article>

          <article className="col-span-12 flex items-center justify-center gap-4 my-4">
            <ButtonOutlined
              onClick={() => {
                setIsOpenModal(false);
                setErrorMessage("");
                setInputComment("");
              }}
              mode="del"
              buttonName="ยกเลิก"
            />

            <ButtonPrimary
              onClick={() => {
                if (!inputComment) {
                  setErrorMessage("กรุณาระบุหมายเหตุ");
                  return;
                }
                onSubmit();
              }}
              mode="next"
              buttonName="ยืนยัน"
            />
          </article>
        </section>
      }
    />
  );
};

export default ModalSubmitTransferAdvisor;
